module.exports = __webpack_public_path__ + "h5/img/zhang.da76e08e.jpeg";